// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ngbc","top":"styles_top__1e26J"};